// extracted by mini-css-extract-plugin
export default {"container":"Header_container__vI36D","logo":"Header_logo__UsziS","list__container":"Header_list__container__1MeaY"};